import { ResetSavingStateAction, SkademeldingActionKeys } from '../../meldskade/reducer/skademelding-actions';
import { SavingState } from '../../reducers/savingState';
import { InternalAttachment } from '../form/attachment-types';
import {
    AddUploadedAttachmentsAction,
    DeleteUploadedAttachmentAction,
    EttersendingActionKeys,
    SaveEttersendingAction,
    SaveEttersendingFailureAction,
    SaveEttersendingSuccessAction,
    SaveEttersendingUnauthorizedFailureAction,
    SaveEttersendingVedleggFailureAction,
    SetSkadenummerAction,
    SetSkadesakExistsAction,
} from './ettersending-actions';

export interface EttersendingState {
    savingState: SavingState;
    attachments: InternalAttachment[];
    skadenummer?: string;
    skadesakExists: boolean;
    validSession: boolean;
}

const initialState: EttersendingState = {
    savingState: SavingState.Initial,
    attachments: [],
    skadenummer: undefined,
    skadesakExists: false,
    validSession: true,
};

type Actions =
    | SetSkadenummerAction
    | SetSkadesakExistsAction
    | AddUploadedAttachmentsAction
    | DeleteUploadedAttachmentAction
    | SaveEttersendingAction
    | SaveEttersendingSuccessAction
    | SaveEttersendingFailureAction
    | SaveEttersendingVedleggFailureAction
    | SaveEttersendingUnauthorizedFailureAction
    | ResetSavingStateAction
    | never;

export const ettersendingReducer = (
    state: EttersendingState = initialState,
    action: Actions = {} as Actions,
): EttersendingState => {
    switch (action.type) {
        case EttersendingActionKeys.SetSkadenummer:
            return {
                ...state,
                skadenummer: action.skadenummer,
            };
        case EttersendingActionKeys.SetSkadesakExists:
            return {
                ...state,
                skadesakExists: action.doesSkadesakExist,
            };
        case EttersendingActionKeys.AddUploadedAttachments:
            return {
                ...state,
                attachments: [...state.attachments, ...action.attachments],
            };
        case EttersendingActionKeys.DeleteUploadedAttachment:
            return {
                ...state,
                attachments: state.attachments.filter((internalAttachment) =>
                    action.attachmentsToBeDeleted.some((a) => a.uploadId !== internalAttachment.uploadId),
                ),
            };
        case EttersendingActionKeys.SaveEttersending:
            return {
                ...state,
                savingState: SavingState.Saving,
            };
        case EttersendingActionKeys.SaveEttersendinggSuccess:
            return {
                ...state,
                savingState: SavingState.Success,
            };
        case EttersendingActionKeys.SaveEttersendingFailure:
            return {
                ...state,
                savingState: SavingState.Failure,
            };
        case EttersendingActionKeys.SaveEttersendingVedleggFailure:
            return {
                ...state,
                savingState: SavingState.UgyldigVedlegg,
            };
        case EttersendingActionKeys.SaveEttersendingUnauthorizedFailure:
            return {
                ...state,
                savingState: SavingState.UnauthorizedUser,
            };
        case SkademeldingActionKeys.ResetSavingState:
            return {
                ...state,
                savingState: initialState.savingState,
                attachments: initialState.attachments,
            };
        default:
            return {
                ...state,
            };
    }
};
